import { create } from 'zustand';
import { HttpApi } from '@/common/http';
import { ENDPOINT_LAND_COUNT } from '@/common/constants';
import { ICount, TNavbar } from './INavbar';

const httpApi = new HttpApi();

const useNavbarStore = create<TNavbar>((set, get) => ({
  countLoading: true,
  count: [],
  fetchNavbar: async () => {
    set({ countLoading: true });
    const res = await httpApi.get<ICount[]>(ENDPOINT_LAND_COUNT, {});
    set({
      count: res,
    });

    setTimeout(() => {
      set({ countLoading: false });
    }, 300);
  },
}));

export default useNavbarStore;
